import { FormFactor } from '../../../models/labs/micromobility/form-factor.enum';
import { IStation } from '../../../models/labs/micromobility/station.model';

export class StationApiModel {
  public id!: number;
  public name!: string;
  public operatorName!: string;
  public latitude!: number;
  public longitude!: number;
  public isOpen!: boolean;
  public formFactor!: FormFactor;
  public availableVehicles!: number;
  public rentalUriAndroid!: string;
  public rentalUriIos!: string;

  public static mapToBusinessModel(apiModel: StationApiModel): IStation {
    return {
      id: apiModel.id,
      name: apiModel.name,
      operatorName: apiModel.operatorName,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      isOpen: apiModel.isOpen,
      formFactor: apiModel.formFactor,
      availableVehicles: apiModel.availableVehicles,
      rentalUriAndroid: apiModel.rentalUriAndroid,
      rentalUriIos: apiModel.rentalUriIos,
    };
  }
}
